<div class="dialog-content">
  <div class="close-button-container">
    <app-modal-close-button
      [closeDialog]="closeDialog.bind(this)"></app-modal-close-button>
  </div>
  <h2 class="title">Bewohner:in Notiz</h2>
  <div class="note-container" [formGroup]="noteForm">
    <textarea
      [maxlength]="noteCharacterLimit"
      formControlName="internalNote"
      placeholder="Fügen Sie hier einen internen Hinweis hinzu, der bei einer Bestellungen für diesen Bewohner:in für Ihre Kolleg:innen zu beachten ist."
      class="note-textarea"></textarea>
    <span class="character-count">
      {{ noteForm.get('internalNote')?.value?.length }}/{{ noteCharacterLimit }}
      Zeichen
    </span>
  </div>
  <div class="flex align-center space-between">
    <app-button
      type="DELETE"
      [withoutLabel]="true"
      [disabled]="!data.resident.internalNote"
      [action]="openDeleteConfirmation.bind(this)"></app-button>
    <div class="flex align-center gap-12px">
      <app-button
        type="CANCEL"
        text="Abbrechen"
        [action]="cancel.bind(this)"></app-button>
      <app-button
        type="SAVE"
        [text]="'Speichern'"
        [disabled]="noteForm.invalid || isSaving || noteForm.pristine"
        [action]="saveNote.bind(this)"></app-button>
    </div>
  </div>
</div>
